// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_CODEPROMOS = "GET_CODEPROMOS";

// Add CODEPROMO
export const ADD_NEW_CODEPROMO = "ADD_NEW_CODEPROMO";
export const ADD_CODEPROMO_SUCCESS = "ADD_CODEPROMO_SUCCESS";
export const ADD_CODEPROMO_FAIL = "ADD_CODEPROMO_FAIL";

// Edit CODEPROMO
export const UPDATE_CODEPROMO = "UPDATE_CODEPROMO";
export const UPDATE_CODEPROMO_SUCCESS = "UPDATE_CODEPROMO_SUCCESS";
export const UPDATE_CODEPROMO_FAIL = "UPDATE_CODEPROMO_FAIL";
